import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import NewArrivalTwo from "./NewArrivalTwo";
import Review from "./Review/Review";
import Swal from "sweetalert2";
import SEO from "./SEO";

const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "INR":
      return "₹";

    case "USD":
      return "$";

    case "EUR":
      return "€";

    case "AED":
      return "AED ";

    case "SAR":
      return "SAR ";

    case "QAR":
      return "QAR ";

    case "GBP":
      return "£";

    default:
      return "$";
  }
};

/* ─────────────────────────────────────────
   AMAZON-STYLE GLOBAL STYLES
   ───────────────────────────────────────── */
const amazonStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Amazon+Ember:wght@300;400;700&display=swap');

  :root {
    --amz-orange: #FF9900;
    --amz-orange-dark: #e47911;
    --amz-blue: #007185;
    --amz-blue-dark: #004b91;
    --amz-text: #0F1111;
    --amz-text-muted: #565959;
    --amz-border: #DDD;
    --amz-bg: #EAEDED;
    --amz-white: #fff;
    --amz-btn-buy: #FFD814;
    --amz-btn-buy-hover: #F7CA00;
    --amz-btn-cart: #FFA41C;
    --amz-btn-cart-hover: #FF8F00;
    --amz-red: #CC0C39;
    --amz-green: #007600;
    --amz-panel-bg: #F0F2F2;
    --amz-sidebar-bg: #fff;
    --amz-radius: 8px;
    --amz-star: #FF9900;
  }

  .amz-pd * { box-sizing: border-box; }

  .amz-pd {
    background: var(--amz-white);
    font-family: 'Amazon Ember', 'Arial', sans-serif;
    font-size: 14px;
    color: var(--amz-text);
    min-height: 100vh;
  }

  /* ── Breadcrumb ── */
  .amz-breadcrumb {
    background: var(--amz-white);
    padding: 6px 20px;
    border-bottom: 1px solid #e7e7e7;
    font-size: 12px;
    color: var(--amz-blue);
  }
  .amz-breadcrumb span { color: var(--amz-text-muted); margin: 0 4px; }
  .amz-breadcrumb a { color: var(--amz-blue); text-decoration: none; }
  .amz-breadcrumb a:hover { color: var(--amz-orange-dark); text-decoration: underline; }

  /* ── Main layout ── */
  .amz-main-container {
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
  display: grid;
  grid-template-columns: 40px 460px 1fr 300px;
  gap: 20px;

  align-items: flex-start;
}

  /* ── Thumbnail rail ── */
  .amz-thumb-rail {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-top: 8px;
  }
  .amz-thumb-rail-btn {
    width: 38px;
    height: 38px;
    border: 2px solid var(--amz-border);
    border-radius: 4px;
 
    cursor: pointer;
    padding: 2px;
    background: var(--amz-white);
    transition: border-color 0.15s;
  }
  .amz-thumb-rail-btn:hover,
  .amz-thumb-rail-btn.active {
    border-color: var(--amz-orange-dark);
  }
  .amz-thumb-rail-btn img,
  .amz-thumb-rail-btn video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .amz-thumb-nav {
    width: 38px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: none;
    border: none;
    color: var(--amz-blue);
    font-size: 18px;
    padding: 0;
  }
  .amz-thumb-nav:hover { color: var(--amz-orange-dark); }

  /* ── Sticky image panel (Amazon style) ── */
  .amz-thumb-col {
  position: sticky;
  top: 90px;
  align-self: flex-start;
  z-index: 20;
  height: fit-content;
}

.amz-image-col {
  position: sticky;
  top: 90px;
  align-self: flex-start;
  z-index: 20;
  height: fit-content;
}
  .amz-main-image-wrap {
    border: 1px solid var(--amz-border);
    border-radius: 4px;
 
    background: var(--amz-white);
    position: relative;
    cursor: zoom-in;
  }
  .amz-main-image-wrap img {
    width: 100%;
    height: auto;
    max-height: 460px;
    object-fit: contain;
    display: block;
    transition: transform 0.1s;
  }
  .amz-zoom-lens {
    position: absolute;
    border: 1px solid var(--amz-border);
    background: rgba(255,255,255,0.35);
    pointer-events: none;
    display: none;
    z-index: 5;
  }
  .amz-main-image-wrap:hover .amz-zoom-lens { display: block; }
  .amz-zoom-result {
    position: absolute;
    top: 0;
    left: calc(100% + 10px);
    width: 460px;
    height: 460px;
    border: 1px solid var(--amz-border);
    background: var(--amz-white);
    background-repeat: no-repeat;
    z-index: 100;
    pointer-events: none;
    display: none;
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.15);
  }
  .amz-main-image-wrap:hover .amz-zoom-result { display: block; }

  /* Video badge */
  .amz-video-badge {
    position: absolute;
    bottom: 8px;
    left: 8px;
    background: rgba(0,0,0,0.7);
    color: #fff;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
  }

  /* ── Scroll hint on image ── */
  .amz-scroll-hint {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0,0,0,0.6);
    color: #fff;
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 10px;
    pointer-events: none;
    white-space: nowrap;
    opacity: 0;
    animation: fadeHint 3s ease forwards;
    z-index: 7;
  }
  @keyframes fadeHint {
    0%   { opacity: 0; }
    15%  { opacity: 1; }
    75%  { opacity: 1; }
    100% { opacity: 0; }
  }

  /* ── Middle: product info ── */
  .amz-info-col {
    padding: 0 8px;
    border-right: 1px solid var(--amz-border);
    min-width: 0;
  }

  .amz-vendor-link {
    font-size: 12px;
    color: var(--amz-blue);
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    margin-bottom: 6px;
  }
  .amz-vendor-link:hover { color: var(--amz-orange-dark); text-decoration: underline; }

  .amz-product-title {
    font-size: 21px;
    font-weight: 400;
    line-height: 1.3;
    color: var(--amz-text);
    margin: 0 0 8px 0;
    word-break: break-word;
  }

  /* Stars */
  .amz-stars-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .amz-stars { color: var(--amz-star); font-size: 14px; letter-spacing: -1px; }
  .amz-rating-count {
    color: var(--amz-blue);
    font-size: 13px;
    cursor: pointer;
    text-decoration: none;
  }
  .amz-rating-count:hover { color: var(--amz-orange-dark); text-decoration: underline; }
  .amz-divider-dot { color: #ccc; font-size: 18px; line-height: 1; }

  /* Price section */
  .amz-price-section {
    padding: 12px 0;
    border-top: 1px solid var(--amz-border);
    border-bottom: 1px solid var(--amz-border);
    margin: 10px 0;
  }
  .amz-price-label { font-size: 12px; color: var(--amz-text-muted); }
  .amz-price-main {
    font-size: 28px;
    font-weight: 400;
    color: var(--amz-red);
    display: flex;
    align-items: flex-start;
    gap: 2px;
    flex-wrap: wrap;
  }
  .amz-price-main .sup { font-size: 14px; margin-top: 6px; }
  .amz-price-main .whole { line-height: 1; }
  .amz-price-main .fraction { font-size: 14px; margin-top: 4px; }
  .amz-price-old {
    font-size: 13px;
    color: var(--amz-text-muted);
  }
  .amz-price-old s { color: var(--amz-text-muted); }
  .amz-discount-badge {
    display: inline-block;
    background: var(--amz-red);
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 3px;
    font-weight: 700;
    margin-left: 6px;
  }
  .amz-coupon-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #F3F3F3;
    border: 1px solid var(--amz-border);
    border-radius: 3px;
    padding: 4px 10px;
    font-size: 12px;
    margin-top: 8px;
    cursor: pointer;
  }
  .amz-coupon-badge input[type="checkbox"] { accent-color: var(--amz-orange); }

  /* Stock */
  .amz-stock-in { color: var(--amz-green); font-size: 17px; font-weight: 400; margin: 8px 0; }
  .amz-stock-out { color: var(--amz-red); font-size: 17px; font-weight: 400; margin: 8px 0; }
  .amz-stock-low { color: var(--amz-orange-dark); font-size: 13px; margin-top: 4px; }

  /* Variant section */
  .amz-variant-section { margin: 12px 0; }
  .amz-variant-label {
    font-size: 14px;
    margin-bottom: 8px;
    color: var(--amz-text);
  }
  .amz-variant-label strong { color: var(--amz-text); }
  .amz-variant-label .selected-val { color: var(--amz-text); font-weight: 700; }

  /* Color swatches - Amazon image-card style */
  .amz-color-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .amz-color-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
  }
  .amz-color-card:disabled { opacity: 0.4; cursor: not-allowed; }
  .amz-color-img-wrap {
    width: 64px;
    height: 64px;
    border: 2px solid var(--amz-border);
    border-radius: 4px;
    background: #f3f4f6;
    position: relative;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .amz-color-card:not(:disabled):hover .amz-color-img-wrap,
  .amz-color-card.active .amz-color-img-wrap {
    border-color: var(--amz-orange-dark);
    box-shadow: 0 0 0 2px rgba(228,121,17,0.3);
  }
  .amz-color-img-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .amz-color-tick {
    position: absolute;
    bottom: 3px;
    right: 3px;
    width: 18px;
    height: 18px;
    background: var(--amz-orange-dark);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .amz-color-name {
    font-size: 11px;
    color: var(--amz-text-muted);
    text-align: center;
    max-width: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: capitalize;
  }
  .amz-color-price {
    font-size: 11px;
    font-weight: 700;
    color: var(--amz-red);
    text-align: center;
  }

  /* Size buttons */
  .amz-size-grid { display: flex; flex-wrap: wrap; gap: 6px; }
  .amz-size-btn {
    min-width: 48px;
    padding: 6px 12px;
    border: 2px solid var(--amz-border);
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    background: var(--amz-white);
    color: var(--amz-text);
    transition: all 0.12s;
    position: relative;
  }
  .amz-size-btn:hover:not(:disabled) { border-color: var(--amz-orange-dark); }
  .amz-size-btn.active { border-color: var(--amz-orange-dark); border-width: 2px; box-shadow: 0 0 0 1px var(--amz-orange-dark); }
  .amz-size-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    text-decoration: line-through;
    background: #f9f9f9;
  }

  /* Description */
  .amz-feature-bullets { padding-left: 18px; margin: 10px 0; }
  .amz-feature-bullets li { margin-bottom: 6px; font-size: 13px; color: var(--amz-text); line-height: 1.5; }

  /* ── Right sidebar (buy box) ── */
  .amz-buybox {
    border: 1px solid var(--amz-border);
    border-radius: var(--amz-radius);
    padding: 18px;
    background: var(--amz-white);
    position: sticky;
    top: 72px;
    font-size: 14px;
    min-width: 200px;
  }
  .amz-buybox-price {
    font-size: 24px;
    color: var(--amz-red);
    font-weight: 400;
    margin-bottom: 4px;
  }
  .amz-buybox-price .sup { font-size: 13px; vertical-align: super; }

  .amz-delivery-line { color: var(--amz-blue); font-size: 13px; margin-bottom: 8px; }
  .amz-delivery-line strong { color: var(--amz-text); }
  .amz-free-return { font-size: 12px; color: var(--amz-blue); margin-bottom: 12px; cursor: pointer; }

  .amz-qty-select {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 10px 0;
  }
  .amz-qty-label { font-size: 13px; color: var(--amz-text-muted); white-space: nowrap; }
  .amz-qty-controls {
    display: flex;
    align-items: center;
    border: 1px solid var(--amz-border);
    border-radius: 20px;
    overflow: hidden;
    background: #F0F2F2;
  }
  .amz-qty-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: #F0F2F2;
    cursor: pointer;
    font-size: 16px;
    color: var(--amz-text);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;
  }
  .amz-qty-btn:hover:not(:disabled) { background: var(--amz-border); }
  .amz-qty-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .amz-qty-num {
    min-width: 32px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    color: var(--amz-text);
    background: var(--amz-white);
    border-left: 1px solid var(--amz-border);
    border-right: 1px solid var(--amz-border);
    padding: 4px 0;
    line-height: 24px;
  }

  .amz-btn-buy {
    width: 100%;
    padding: 9px 10px;
    background: var(--amz-btn-buy);
    border: 1px solid #FCD200;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    color: var(--amz-text);
    font-weight: 500;
    margin-bottom: 8px;
    transition: background 0.15s;
  }
  .amz-btn-buy:hover { background: var(--amz-btn-buy-hover); }
  .amz-btn-buy:disabled { opacity: 0.5; cursor: not-allowed; }

  .amz-btn-cart {
    width: 100%;
    padding: 9px 10px;
    background: var(--amz-btn-cart);
    border: 1px solid #FF8F00;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    color: var(--amz-text);
    font-weight: 500;
    margin-bottom: 8px;
    transition: background 0.15s;
  }
  .amz-btn-cart:hover { background: var(--amz-btn-cart-hover); }
  .amz-btn-cart:disabled { opacity: 0.5; cursor: not-allowed; }

  .amz-btn-wishlist {
    width: 100%;
    padding: 9px 10px;
    background: var(--amz-white);
    border: 1px solid var(--amz-border);
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    color: var(--amz-text);
    transition: background 0.15s, border-color 0.15s;
  }
  .amz-btn-wishlist:hover { background: #f7f7f7; border-color: #aaa; }
  .amz-btn-wishlist.active { border-color: var(--amz-orange-dark); color: var(--amz-red); }

  .amz-secure-line {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--amz-text-muted);
    margin: 8px 0;
    justify-content: center;
  }

  .amz-share-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    border-top: 1px solid var(--amz-border);
    padding-top: 10px;
  }
  .amz-share-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid var(--amz-border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    color: var(--amz-text);
    transition: background 0.15s, border-color 0.15s;
  }
  .amz-share-btn:hover { background: #f7f7f7; border-color: #aaa; }

  /* ── Service info in buybox ── */
  .amz-service-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    color: var(--amz-text-muted);
    margin-bottom: 8px;
    line-height: 1.4;
  }
  .amz-service-item i { color: var(--amz-blue); font-size: 15px; flex-shrink: 0; margin-top: 1px; }
  .amz-service-item strong { color: var(--amz-text); }

  /* ── Variant warning ── */
  .amz-variant-warn {
    background: #FFF8E1;
    border: 1px solid #FFCA28;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 12px;
    color: #6D4C00;
    margin: 8px 0;
  }

  /* ── Mobile ── */
  @media (max-width: 991px) {
    .amz-main-container {
      grid-template-columns: 1fr;
      padding: 0;
      gap: 0;
    }
    .amz-thumb-col { display: none; }
    .amz-image-col { position: static; border-bottom: 1px solid var(--amz-border); }
    .amz-info-col { padding: 14px 16px; border-right: none; border-bottom: 1px solid var(--amz-border); }
    .amz-buybox { position: static; border-radius: 0; border-left: none; border-right: none; border-top: none; margin-top: 0; }
    .amz-main-image-wrap img { max-height: 320px; }
    .amz-mobile-thumbs {
      display: flex !important;
      gap: 6px;
      padding: 8px 12px;
      overflow-x: auto;
      scrollbar-width: none;
      border-bottom: 1px solid var(--amz-border);
    }
    .amz-mobile-thumbs::-webkit-scrollbar { display: none; }
    .amz-mobile-thumb {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      border: 2px solid var(--amz-border);
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      background: var(--amz-white);
    }
    .amz-mobile-thumb.active { border-color: var(--amz-orange-dark); }
    .amz-mobile-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
    .amz-product-title { font-size: 17px; }
    .amz-zoom-result { display: none !important; }
  }

  /* ── Lightbox ── */
  .amz-lightbox-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.92);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .amz-lightbox-close {
    position: absolute;
    top: 16px; right: 20px;
    color: #fff;
    font-size: 32px;
    cursor: pointer;
    background: none;
    border: none;
    line-height: 1;
  }
  .amz-lightbox-img {
    max-width: 92vw;
    max-height: 92vh;
    object-fit: contain;
    border-radius: 4px;
  }
  .amz-lightbox-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255,255,255,0.15);
    color: #fff;
    border: none;
    font-size: 28px;
    padding: 12px 8px;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.15s;
  }
  .amz-lightbox-nav:hover { background: rgba(255,255,255,0.3); }
  .amz-lightbox-nav.prev { left: 12px; }
  .amz-lightbox-nav.next { right: 12px; }

  /* ── Share modal ── */
  .amz-share-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(3px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .amz-share-modal {
    background: #fff;
    border-radius: 10px;
    padding: 24px;
    width: 90%;
    max-width: 400px;
    position: relative;
    box-shadow: 0 8px 40px rgba(0,0,0,0.25);
  }
  .amz-share-modal h3 { font-size: 17px; font-weight: 700; margin: 0 0 16px; color: var(--amz-text); }
  .amz-share-url-row {
    display: flex;
    border: 1px solid var(--amz-border);
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 18px;
  }
  .amz-share-url-input {
    flex: 1;
    border: none;
    outline: none;
    padding: 8px 12px;
    font-size: 13px;
    color: var(--amz-text-muted);
    background: #f9f9f9;
  }
  .amz-share-copy-btn {
    padding: 8px 16px;
    background: var(--amz-orange-dark);
    color: #fff;
    border: none;
    font-size: 13px;
    cursor: pointer;
    font-weight: 600;
  }
  .amz-share-icons { display: flex; gap: 10px; justify-content: center; }
  .amz-share-icon-btn {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #fff;
    text-decoration: none;
    transition: transform 0.15s, box-shadow 0.15s;
    border: none;
    cursor: pointer;
  }
  .amz-share-icon-btn:hover { transform: translateY(-2px); }
  .amz-share-modal-close {
    position: absolute;
    top: 12px; right: 14px;
    background: #f3f4f6;
    border: none;
    cursor: pointer;
    width: 28px; height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #6b7280;
  }

  /* ── Progress bar ── */
  .amz-stock-bar-wrap {
    background: #e5e7eb;
    border-radius: 4px;
    height: 6px;
    margin: 8px 0 4px;
    overflow: hidden;
  }
  .amz-stock-bar-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.6s ease;
  }

  /* ── Section divider ── */
  .amz-divider { border: none; border-top: 1px solid var(--amz-border); margin: 16px 0; }

  /* ── From the brand ── */
  .amz-vendor-card {
    border: 1px solid var(--amz-border);
    border-radius: var(--amz-radius);
    padding: 14px 16px;
    margin: 12px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: border-color 0.15s;
  }
  .amz-vendor-card:hover { border-color: var(--amz-orange-dark); }
  .amz-vendor-card h6 { margin: 0; font-size: 13px; color: var(--amz-blue); font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
  .amz-vendor-card p { margin: 2px 0 0; font-size: 12px; color: var(--amz-text-muted); }

  /* ── About section ── */
  .amz-about-section { margin: 20px 0; }
  .amz-about-section h2 { font-size: 17px; font-weight: 700; margin-bottom: 10px; border-bottom: 1px solid var(--amz-border); padding-bottom: 6px; }
  .amz-about-text { font-size: 14px; color: var(--amz-text); line-height: 1.7; }
`;

/* ─────────────────────────────────────────
   HELPERS
   ───────────────────────────────────────── */
const getUniqueColors = (variants = []) => [
  ...new Set(variants.map((v) => v.color).filter(Boolean)),
];

const getSizesForColor = (variants = [], color) => [
  ...new Set(
    variants
      .filter((v) => v.color === color)
      .map((v) => v.size)
      .filter(Boolean),
  ),
];

const findVariant = (variants = [], color, size) => {
  if (!variants.length) return null;
  if (!color && !size) return variants[0] || null;
  return (
    variants.find((v) => {
      if (v.color && !v.size) return v.color === color;
      return v.color === color && v.size === size;
    }) || null
  );
};

/* Star renderer */
const renderStars = (rating = 4.3) => {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  let stars = "";
  for (let i = 0; i < full; i++) stars += "★";
  if (half) stars += "☆";
  return stars;
};

/* Format price like Amazon: ₹1,299.00 → sup + whole + fraction */
const formatAmazonPrice = (price) => {
  const [whole, frac] = price.toFixed(2).split(".");
  return { whole: parseInt(whole).toLocaleString("en-IN"), frac };
};

/* ─────────────────────────────────────────
   MAIN COMPONENT
   ───────────────────────────────────────── */
const ProductDetailsOne = ({ selectedCurrency }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [mainImageIdx, setMainImageIdx] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [shareModal, setShareModal] = useState(false);
  const [lightbox, setLightbox] = useState(false);
  const [lightboxIdx, setLightboxIdx] = useState(0);
  const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });
  const [showZoom, setShowZoom] = useState(false);
  const [showScrollHint, setShowScrollHint] = useState(false);

  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [activeVariant, setActiveVariant] = useState(null);
  const [displayMedia, setDisplayMedia] = useState([]);

  const imageRef = useRef(null);
  const lensRef = useRef(null);
  const zoomResultRef = useRef(null);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);
  const wheelLock = useRef(false);
  // const imageColRef = useRef(null);
  // const thumbColRef = useRef(null);
  // const lastScrollY = useRef(window.scrollY);
  // const imageColTop = useRef(72);

  /* ── Amazon sticky scroll */
  // useEffect(() => {
  //   const NAVBAR_H = 72;
  //   const BOTTOM_MARGIN = 16;

  //   const onScroll = () => {
  //     const col = imageColRef.current;
  //     const thumbCol = thumbColRef.current;
  //     if (!col) return;

  //     const colH = col.offsetHeight;
  //     const viewH = window.innerHeight;
  //     const scrollY = window.scrollY;
  //     const delta = scrollY - lastScrollY.current;
  //     lastScrollY.current = scrollY;

  //     if (colH <= viewH - NAVBAR_H) {
  //       // Image fits in viewport — just stick to top
  //       col.style.position = "sticky";
  //       col.style.top = NAVBAR_H + "px";
  //       col.style.bottom = "auto";
  //       if (thumbCol) {
  //         thumbCol.style.position = "sticky";
  //         thumbCol.style.top = NAVBAR_H + "px";
  //         thumbCol.style.bottom = "auto";
  //       }
  //       return;
  //     }

  //     // Image taller than viewport: scroll it until fully revealed, then lock
  //     let newTop = imageColTop.current - delta;

  //     // Clamp: top can't go higher than NAVBAR_H (top of viewport)
  //     const minTop = viewH - colH - BOTTOM_MARGIN; // negative — bottom of image at bottom of viewport
  //     const maxTop = NAVBAR_H;
  //     newTop = Math.max(minTop, Math.min(maxTop, newTop));

  //     imageColTop.current = newTop;
  //     col.style.position = "sticky";
  //     col.style.top = newTop + "px";
  //     col.style.bottom = "auto";

  //     if (thumbCol) {
  //       thumbCol.style.position = "sticky";
  //       thumbCol.style.top = newTop + "px";
  //       thumbCol.style.bottom = "auto";
  //     }
  //   };

  //   window.addEventListener("scroll", onScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, []);

  /* ── Inject styles ── */
  useEffect(() => {
    const id = "amz-styles";
    let tag = document.getElementById(id);
    if (!tag) {
      tag = document.createElement("style");
      tag.id = id;
      document.head.appendChild(tag);
    }
    tag.innerHTML = amazonStyles;
  }, []);

  /* ── Fetch product ── */
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/product/edit/${id}`,
        );
        if (res.data.success) {
          const data = res.data.data;
          const globalMedia = [
            ...(data.images || []).map((url) => ({ url, type: "image" })),
            ...(data.videos || []).map((url) => ({ url, type: "video" })),
          ];
          setProduct({ ...data, globalMedia });
          setDisplayMedia(globalMedia);
          setMainImageIdx(0);
          if (globalMedia.length > 1) {
            setShowScrollHint(true);
            setTimeout(() => setShowScrollHint(false), 3200);
          }
          if (data.variants?.length > 0) {
            const first = data.variants[0];
            setSelectedColor(first.color || "");
            setSelectedSize(first.size || "");
            setActiveVariant(first);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchProduct();
  }, [id]);

  /* ── Variant change ── */
  useEffect(() => {
    if (!product) return;
    const variant = findVariant(
      product.variants || [],
      selectedColor,
      selectedSize,
    );
    setActiveVariant(variant);
    const variantMedia = (variant?.images || []).map((url) => ({
      url,
      type: "image",
    }));
    // const merged = [...(product.globalMedia || []), ...variantMedia];
    // const newMedia = merged.length > 0 ? merged : [{ url: "assets/images/thumbs/no-image.png", type: "image" }];
    // setDisplayMedia(newMedia);
    // setMainImageIdx(variantMedia.length > 0 ? (product.globalMedia || []).length : 0);
    const newMedia =
      variantMedia.length > 0 ? variantMedia : product.globalMedia || [];

    setDisplayMedia(
      newMedia.length > 0
        ? newMedia
        : [{ url: "assets/images/thumbs/no-image.png", type: "image" }],
    );

    setMainImageIdx(0);
  }, [selectedColor, selectedSize, product]);

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    const colorVariants = (product?.variants || []).filter(
      (v) => v.color === color,
    );
    const noSizeVariant = colorVariants.find((v) => !v.size);
    if (noSizeVariant) {
      setSelectedSize("");
      return;
    }
    const sizes = getSizesForColor(product?.variants || [], color);
    setSelectedSize(sizes[0] || "");
  };

  /* ── Cart/fav sync ── */
  useEffect(() => {
    setCart(JSON.parse(localStorage.getItem("cart")) || []);
  }, []);
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);
  useEffect(() => {
    setFavorites(JSON.parse(localStorage.getItem("favorites")) || []);
  }, []);

  /* ── Derived values ── */
  const variantPrice =
    activeVariant?.price ||
    product?.variants?.[0]?.price ||
    product?.price ||
    {};

  const displayPrice =
    typeof variantPrice === "object"
      ? variantPrice?.[selectedCurrency] || variantPrice?.INR
      : variantPrice || 0;
  const variantOldPrice =
    activeVariant?.oldPrice ||
    product?.variants?.[0]?.oldPrice ||
    product?.oldPrice ||
    null;

  const displayOldPrice =
    typeof variantOldPrice === "object"
      ? variantOldPrice?.[selectedCurrency] || variantOldPrice?.INR
      : variantOldPrice;
  const displayStock = activeVariant?.stock ?? product?.stock ?? 0;
  const hasVariants = product?.variants?.length > 0;
  const colors = getUniqueColors(product?.variants || []);
  const sizes = getSizesForColor(product?.variants || [], selectedColor);
  const isFav = product ? favorites.some((i) => i.id === product._id) : false;
  const mainMedia = displayMedia[mainImageIdx] ||
    displayMedia[0] || {
      url: "assets/images/thumbs/no-image.png",
      type: "image",
    };
  const discountPct =
    displayOldPrice && displayPrice
      ? Math.round(((displayOldPrice - displayPrice) / displayOldPrice) * 100)
      : 0;

  const shareUrl = product
    ? `${window.location.origin}/product-details/${product._id}`
    : "";

  /* ── Zoom handler ── */
  const handleMouseMove = useCallback(
    (e) => {
      if (!imageRef.current || !lensRef.current || !zoomResultRef.current)
        return;
      const rect = imageRef.current.getBoundingClientRect();
      const lens = lensRef.current;
      const result = zoomResultRef.current;
      const lensW = lens.offsetWidth;
      const lensH = lens.offsetHeight;
      let x = e.clientX - rect.left - lensW / 2;
      let y = e.clientY - rect.top - lensH / 2;
      x = Math.max(0, Math.min(x, rect.width - lensW));
      y = Math.max(0, Math.min(y, rect.height - lensH));
      lens.style.left = x + "px";
      lens.style.top = y + "px";
      const cx = result.offsetWidth / lensW;
      const cy = result.offsetHeight / lensH;
      result.style.backgroundImage = `url('${mainMedia.url}')`;
      result.style.backgroundSize = `${rect.width * cx}px ${rect.height * cy}px`;
      result.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
    },
    [mainMedia],
  );

  /* ── Wheel scroll to cycle images ── */
  const handleWheel = useCallback(
    (e) => {
      if (!displayMedia.length) return;
      e.preventDefault();
      if (wheelLock.current) return;
      wheelLock.current = true;
      setTimeout(() => {
        wheelLock.current = false;
      }, 300);
      if (e.deltaY > 0) {
        setMainImageIdx((i) => (i + 1) % displayMedia.length);
      } else {
        setMainImageIdx(
          (i) => (i - 1 + displayMedia.length) % displayMedia.length,
        );
      }
    },
    [displayMedia.length],
  );

  /* ── Touch swipe to cycle images ── */
  const handleTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const handleTouchEnd = useCallback(
    (e) => {
      if (touchStartX.current === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX.current;
      const dy = e.changedTouches[0].clientY - touchStartY.current;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        if (dx < 0) {
          setMainImageIdx((i) => (i + 1) % displayMedia.length);
        } else {
          setMainImageIdx(
            (i) => (i - 1 + displayMedia.length) % displayMedia.length,
          );
        }
      }
      touchStartX.current = null;
      touchStartY.current = null;
    },
    [displayMedia.length],
  );

  /* ── Attach non-passive wheel listener so we can preventDefault ── */
  useEffect(() => {
    const el = imageRef.current;
    if (!el) return;
    const handler = (e) => handleWheel(e);
    el.addEventListener("wheel", handler, { passive: false });
    return () => el.removeEventListener("wheel", handler);
  }, [handleWheel]);

  /* ── Actions ── */
  const toggleFavorite = () => {
    if (!product) return;
    const updatedFavs = [...favorites];
    const index = updatedFavs.findIndex((i) => i.id === product._id);
    if (index > -1) {
      updatedFavs.splice(index, 1);
      Swal.fire({
        toast: true,
        icon: "warning",
        title: "Removed from Wish List",
        position: "top-end",
        timer: 1500,
        showConfirmButton: false,
      });
    } else {
      updatedFavs.push({
        id: product._id,
        name: product.name,
        price: displayPrice,
        images: product.images,
      });
      Swal.fire({
        toast: true,
        icon: "success",
        title: "Added to Wish List",
        position: "top-end",
        timer: 1500,
        showConfirmButton: false,
      });
    }
    setFavorites(updatedFavs);
    localStorage.setItem("favorites", JSON.stringify(updatedFavs));
  };

  const handleAddToCart = () => {
    if (!product) return;
    if (displayStock < 1) {
      Swal.fire({
        icon: "error",
        title: "Out of Stock",
        timer: 1200,
        showConfirmButton: false,
      });
      return;
    }
    const cartKey = `${product._id}_${selectedColor}_${selectedSize}`;
    const existing = cart.find((i) => i.cartKey === cartKey);
    const cartItem = {
      cartKey,
      id: product._id,
      name: product.name,
      image: displayMedia[0]?.url || "",
      color: selectedColor || null,
      size: selectedSize || null,
      variantId: activeVariant?._id || null,
      qty: quantity,
      stock: displayStock,
      price: activeVariant?.price?.[selectedCurrency] || 0,
      oldPrice: activeVariant?.oldPrice?.[selectedCurrency] || null,
      allPrices: activeVariant?.price || {},
      allOldPrices: activeVariant?.oldPrice || {},
    };
    const newCart = existing
      ? cart.map((i) =>
          i.cartKey === cartKey ? { ...i, qty: i.qty + quantity } : i,
        )
      : [...cart, cartItem];
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
    Swal.fire({
      icon: "success",
      title: "Added to Cart!",
      timer: 1200,
      showConfirmButton: false,
    });
  };

  if (!product)
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          fontFamily: "Arial, sans-serif",
          fontSize: 16,
          color: "#0F1111",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: 40,
              height: 40,
              border: "4px solid #FF9900",
              borderTop: "4px solid transparent",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
              margin: "0 auto 12px",
            }}
          />
          Loading product details...
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );

  const priceFormatted = formatAmazonPrice(Number(displayPrice));

  /* ══════════════════════ RENDER ══════════════════════ */
  return (
    <>
      <SEO
        title={`${product.name} | Buy Online at Best Price`}
        description={
          product.description?.substring(0, 155) ||
          `Buy ${product.name} at best price.`
        }
        canonical={`${window.location.origin}/product-details/${product._id}`}
        schema={{
          "@context": "https://schema.org/",
          "@type": "Product",
          name: product.name,
          image: product.images || [],
          description: product.description,
          offers: {
            "@type": "Offer",
            price: displayPrice,
            priceCurrency: selectedCurrency || "INR",
            availability:
              displayStock > 0
                ? "https://schema.org/InStock"
                : "https://schema.org/OutOfStock",
            url: `${window.location.origin}/product-details/${product._id}`,
          },
        }}
      />

      <div className="amz-pd">
        {/* ── Breadcrumb ── */}
        <div className="amz-breadcrumb">
          <a href="/">Home</a>
          <span>›</span>
          {product.category && (
            <>
              <a href="#">{product.category?.name ?? product.category}</a>
              <span>›</span>
            </>
          )}
          <span style={{ color: "#0F1111" }}>
            {product.name?.substring(0, 60)}
            {product.name?.length > 60 ? "…" : ""}
          </span>
        </div>

        {/* ── Main grid ── */}
        <div className="amz-main-container">
          {/* ── Col 1: Vertical thumbnail rail (desktop) ── */}
          <div className="amz-thumb-col">
            {displayMedia.length > 1 && (
              <div className="amz-thumb-rail">
                {displayMedia.map((item, idx) => (
                  <button
                    key={idx}
                    className={`amz-thumb-rail-btn ${mainImageIdx === idx ? "active" : ""}`}
                    onClick={() => setMainImageIdx(idx)}
                    title={`View image ${idx + 1}`}
                  >
                    {item.type === "image" ? (
                      <img src={item.url} alt={`thumb-${idx}`} />
                    ) : (
                      <video src={item.url} muted />
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* ── Col 2: Main image (sticky) ── */}
          <div className="amz-image-col">
            <div
              className="amz-main-image-wrap"
              ref={imageRef}
              onMouseMove={
                mainMedia.type === "image" ? handleMouseMove : undefined
              }
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
              onClick={() => {
                setLightboxIdx(mainImageIdx);
                setLightbox(true);
              }}
            >
              {mainMedia.type === "image" ? (
                <>
                  <img
                    src={mainMedia.url}
                    alt={`${product.name} buy online`}
                    loading="eager"
                  />
                  {/* Zoom lens */}
                  <div
                    ref={lensRef}
                    className="amz-zoom-lens"
                    style={{ width: 120, height: 120 }}
                  />
                  {/* Zoom result */}
                  <div ref={zoomResultRef} className="amz-zoom-result" />

                  {/* Image counter badge */}
                  {displayMedia.length > 1 && (
                    <div
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        background: "rgba(0,0,0,0.52)",
                        color: "#fff",
                        fontSize: 11,
                        padding: "3px 8px",
                        borderRadius: 10,
                        pointerEvents: "none",
                        zIndex: 6,
                        fontWeight: 500,
                      }}
                    >
                      {mainImageIdx + 1} / {displayMedia.length}
                    </div>
                  )}

                  {/* Dot indicators */}
                  {displayMedia.length > 1 && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 10,
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex",
                        gap: 5,
                        zIndex: 6,
                        pointerEvents: "none",
                      }}
                    >
                      {displayMedia.map((_, idx) => (
                        <span
                          key={idx}
                          style={{
                            width: mainImageIdx === idx ? 18 : 6,
                            height: 6,
                            borderRadius: 3,
                            background:
                              mainImageIdx === idx
                                ? "#e47911"
                                : "rgba(0,0,0,0.28)",
                            transition: "width 0.2s, background 0.2s",
                            display: "block",
                          }}
                        />
                      ))}
                    </div>
                  )}

                  {/* Scroll/swipe hint */}
                  {showScrollHint && displayMedia.length > 1 && (
                    <div className="amz-scroll-hint">
                      🖱 Scroll to browse images
                    </div>
                  )}
                </>
              ) : (
                <>
                  <video
                    src={mainMedia.url}
                    controls
                    style={{
                      width: "100%",
                      maxHeight: 460,
                      display: "block",
                      background: "#000",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span className="amz-video-badge">▶ Video</span>
                </>
              )}
            </div>

            {/* Mobile thumb strip */}
            {displayMedia.length > 1 && (
              <div className="amz-mobile-thumbs" style={{ display: "none" }}>
                {displayMedia.map((item, idx) => (
                  <div
                    key={idx}
                    className={`amz-mobile-thumb ${mainImageIdx === idx ? "active" : ""}`}
                    onClick={() => setMainImageIdx(idx)}
                  >
                    {item.type === "image" ? (
                      <img src={item.url} alt={`t${idx}`} />
                    ) : (
                      <video
                        src={item.url}
                        muted
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Share row below image */}
            <div className="amz-share-row">
              <span style={{ fontSize: 12, color: "#565959" }}>Share:</span>
              {[
                {
                  href: `https://wa.me/?text=${encodeURIComponent(shareUrl)}`,
                  bg: "#25D366",
                  icon: "ph-whatsapp-logo",
                },
                {
                  href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                  bg: "#1877F2",
                  icon: "ph-facebook-logo",
                },
                {
                  href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
                  bg: "#000",
                  icon: "ph-twitter-logo",
                },
                {
                  href: `https://mail.google.com/mail/u/0/=${encodeURIComponent(shareUrl)}`,
                  bg: "#EA4335",
                  icon: "ph-envelope",
                },
              ].map(({ href, bg, icon }) => (
                <a
                  key={icon}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="amz-share-btn"
                  style={{ background: bg, color: "#fff", border: "none" }}
                >
                  <i className={`ph ${icon}`} />
                </a>
              ))}
              <button
                onClick={() => setShareModal(true)}
                className="amz-share-btn"
                style={{
                  fontSize: 12,
                  width: "auto",
                  padding: "0 10px",
                  borderRadius: 4,
                }}
              >
                More
              </button>
            </div>
          </div>

          {/* ── Col 3: Product info ── */}
          <div className="amz-info-col">
            {/* Vendor */}
            {product.vendorId && (
              <span
                className="amz-vendor-link"
                onClick={() => navigate(`/vendor/${product.vendorId._id}`)}
              >
                Visit the <strong>{product.vendorId?.businessName}</strong>{" "}
                Store
              </span>
            )}

            {/* Title */}
            <h1 className="amz-product-title">{product.name}</h1>

            {/* Stars row */}
            {/* <div className="amz-stars-row">
              <span className="amz-stars">{renderStars(4.3)}</span>
              <a href="#reviews" className="amz-rating-count">
                4.3 out of 5
              </a>
              <span className="amz-divider-dot">|</span>
              <a href="#reviews" className="amz-rating-count">
                See all reviews
              </a>
            </div> */}

            <hr className="amz-divider" />

            {/* Price */}
            <div className="amz-price-section">
              <div className="amz-price-label">Price:</div>
              <div className="amz-price-main">
                <span className="sup">
                  {getCurrencySymbol(selectedCurrency)}
                </span>
                <span className="whole">{priceFormatted.whole}</span>
                <span className="fraction">.{priceFormatted.frac}</span>
                {discountPct > 0 && (
                  <span className="amz-discount-badge">{discountPct}% off</span>
                )}
              </div>
              {displayOldPrice && (
                <div className="amz-price-old">
                  <s>
                    {getCurrencySymbol(selectedCurrency)}

                    {Number(displayOldPrice).toFixed(2)}
                  </s>
                </div>
              )}
              <div style={{ fontSize: 12, color: "#007600", marginTop: 4 }}>
                Inclusive of all taxes
              </div>
            </div>

            {/* Stock */}
            {displayStock > 0 ? (
              <>
                <div className="amz-stock-in">
                  {displayStock <= 10
                    ? `Only ${displayStock} left in stock – order soon.`
                    : "In Stock"}
                </div>
                {displayStock <= 30 && (
                  <div className="amz-stock-bar-wrap">
                    <div
                      className="amz-stock-bar-fill"
                      style={{
                        width: `${Math.min(Math.max((displayStock / (product.stock || 100)) * 100, 5), 100)}%`,
                        background:
                          displayStock <= 5
                            ? "#CC0C39"
                            : displayStock <= 15
                              ? "#e47911"
                              : "#007600",
                      }}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="amz-stock-out">Currently unavailable.</div>
            )}

            {/* Variants */}
            {hasVariants && (
              <div className="amz-variant-section">
                <hr className="amz-divider" />

                {/* Color */}
                {colors.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div className="amz-variant-label">
                      Color:{" "}
                      <span className="selected-val">{selectedColor}</span>
                    </div>
                    <div className="amz-color-grid">
                      {colors.map((color) => {
                        const colorVariant = (product.variants || []).find(
                          (v) => v.color === color,
                        );
                        const colorImage =
                          colorVariant?.images?.[0] ||
                          product.images?.[0] ||
                          null;
                        const colorPriceObj =
                          colorVariant?.price || product?.price || {};

                        const colorPrice =
                          typeof colorPriceObj === "object"
                            ? colorPriceObj?.[selectedCurrency] ||
                              colorPriceObj?.INR
                            : colorPriceObj || 0;
                        const colorOldPriceObj =
                          colorVariant?.oldPrice || product?.oldPrice || null;

                        const colorOldPrice =
                          typeof colorOldPriceObj === "object"
                            ? colorOldPriceObj?.[selectedCurrency] ||
                              colorOldPriceObj?.INR
                            : colorOldPriceObj;
                        const allOutOfStock = (product.variants || [])
                          .filter((v) => v.color === color)
                          .every((v) => (v.stock ?? 0) <= 0);
                        const isSelected = selectedColor === color;
                        return (
                          <button
                            key={color}
                            className={`amz-color-card ${isSelected ? "active" : ""}`}
                            disabled={allOutOfStock}
                            onClick={() =>
                              !allOutOfStock && handleColorSelect(color)
                            }
                            title={color}
                          >
                            <span className="amz-color-img-wrap">
                              {colorImage ? (
                                <img
                                  src={colorImage}
                                  alt={color}
                                  style={{
                                    filter: allOutOfStock
                                      ? "grayscale(80%)"
                                      : "none",
                                  }}
                                />
                              ) : (
                                <span
                                  style={{
                                    display: "block",
                                    width: "100%",
                                    height: "100%",
                                    background: CSS.supports("color", color)
                                      ? color
                                      : "#d1d5db",
                                  }}
                                />
                              )}
                              {isSelected && (
                                <span className="amz-color-tick">
                                  <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M2 5l2.2 2.2L8 3"
                                      stroke="#fff"
                                      strokeWidth="1.6"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              )}
                            </span>
                            <span className="amz-color-name">{color}</span>
                            {colorOldPrice && (
                              <span
                                style={{
                                  fontSize: 9,
                                  color: "#9ca3af",
                                  textDecoration: "line-through",
                                  textAlign: "center",
                                }}
                              >
                                {selectedCurrency}
                                {getCurrencySymbol(selectedCurrency)}

                                {Number(colorOldPrice).toFixed(0)}
                              </span>
                            )}
                            <span className="amz-color-price">
                              {getCurrencySymbol(selectedCurrency)}

                              {Number(colorPrice).toFixed(0)}
                            </span>
                            {allOutOfStock && (
                              <span
                                style={{
                                  fontSize: 9,
                                  color: "#CC0C39",
                                  textAlign: "center",
                                }}
                              >
                                Sold out
                              </span>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Size */}
                {sizes.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div className="amz-variant-label">
                      Size: <span className="selected-val">{selectedSize}</span>
                      <a
                        href="#size-chart"
                        style={{
                          fontSize: 12,
                          color: "#007185",
                          marginLeft: 10,
                          textDecoration: "none",
                        }}
                      >
                        Size chart
                      </a>
                    </div>
                    <div className="amz-size-grid">
                      {sizes.map((size) => {
                        const variant = findVariant(
                          product.variants,
                          selectedColor,
                          size,
                        );
                        const outOfStock = (variant?.stock ?? 0) <= 0;
                        return (
                          <button
                            key={size}
                            className={`amz-size-btn ${selectedSize === size ? "active" : ""}`}
                            disabled={outOfStock}
                            onClick={() => !outOfStock && setSelectedSize(size)}
                          >
                            {size}
                            {outOfStock && (
                              <span
                                style={{
                                  fontSize: 10,
                                  display: "block",
                                  color: "#CC0C39",
                                }}
                              >
                                Sold out
                              </span>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {selectedColor && !activeVariant && (
                  <div className="amz-variant-warn">
                    ⚠ This combination is currently unavailable. Please choose a
                    different option.
                  </div>
                )}
              </div>
            )}

            <hr className="amz-divider" />

            {/* About this item */}
            <div className="amz-about-section">
              <h2>About this item</h2>
              <p className="amz-about-text">
                {product.description || "No description available."}
              </p>
            </div>

            {/* Vendor card */}
            {product.vendorId && (
              <div
                className="amz-vendor-card"
                onClick={() => navigate(`/vendor/${product.vendorId._id}`)}
              >
                <div>
                  <h6>VISIT THE {product.vendorId?.businessName} STORE</h6>
                  <p>See more products from this seller</p>
                </div>
                <i
                  className="ph ph-arrow-right"
                  style={{ color: "#007185", fontSize: 18 }}
                />
              </div>
            )}
          </div>

          {/* ── Col 4: Buy box (sticky) ── */}
          <div>
            <div className="amz-buybox">
              {/* Price */}
              <div className="amz-buybox-price">
                <span className="sup">
                  {getCurrencySymbol(selectedCurrency)}{" "}
                </span>
                {priceFormatted.whole}.{priceFormatted.frac}
                {discountPct > 0 && (
                  <span
                    style={{
                      fontSize: 12,
                      background: "#CC0C39",
                      color: "#fff",
                      padding: "2px 6px",
                      borderRadius: 3,
                      marginLeft: 8,
                      fontWeight: 700,
                    }}
                  >
                    {discountPct}% off
                  </span>
                )}
              </div>

              {displayOldPrice && (
                <div
                  style={{ fontSize: 12, color: "#565959", marginBottom: 6 }}
                >
                  <s>{Number(displayOldPrice).toFixed(2)}</s>
                </div>
              )}

              {/* Delivery */}
              <div className="amz-delivery-line">
                <strong>FREE delivery</strong> on orders above ₹499
              </div>
              <div className="amz-delivery-line" style={{ marginBottom: 12 }}>
                Delivers to <strong>your location</strong>
              </div>

              {/* Stock */}
              {displayStock > 0 ? (
                <div
                  style={{ color: "#007600", fontSize: 17, marginBottom: 10 }}
                >
                  {displayStock <= 5
                    ? `Only ${displayStock} left in stock!`
                    : "In Stock"}
                </div>
              ) : (
                <div
                  style={{ color: "#CC0C39", fontSize: 17, marginBottom: 10 }}
                >
                  Currently unavailable
                </div>
              )}

              {/* Quantity */}
              <div className="amz-qty-select">
                <span className="amz-qty-label">Qty:</span>
                <div className="amz-qty-controls">
                  <button
                    className="amz-qty-btn"
                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                    disabled={quantity <= 1}
                  >
                    −
                  </button>
                  <span className="amz-qty-num">{quantity}</span>
                  <button
                    className="amz-qty-btn"
                    onClick={() => {
                      if (quantity >= displayStock) {
                        Swal.fire({
                          toast: true,
                          icon: "warning",
                          title: "Not enough stock",
                          position: "top-end",
                          timer: 1200,
                          showConfirmButton: false,
                        });
                        return;
                      }
                      setQuantity((q) => q + 1);
                    }}
                    disabled={quantity >= displayStock}
                  >
                    +
                  </button>
                </div>
              </div>

              {/* Buy now */}
              <button
                className="amz-btn-buy"
                disabled={displayStock < 1 || (hasVariants && !activeVariant)}
                onClick={() => {
                  handleAddToCart();
                  // navigate to checkout if needed
                }}
              >
                Buy Now
              </button>

              {/* Add to cart */}
              <button
                className="amz-btn-cart"
                disabled={displayStock < 1 || (hasVariants && !activeVariant)}
                onClick={handleAddToCart}
              >
                Add to Cart
              </button>

              {/* Wishlist */}
              <button
                className={`amz-btn-wishlist ${isFav ? "active" : ""}`}
                onClick={toggleFavorite}
              >
                {isFav ? "❤ Remove from Wish List" : "♡ Add to Wish List"}
              </button>

              {/* Secure */}
              <div className="amz-secure-line">
                <i className="ph-fill ph-lock" style={{ color: "#565959" }} />
                Secure transaction
              </div>

              <hr className="amz-divider" />

              {/* Service info */}
              {[
                // {
                //   icon: "ph-fill ph-truck",
                //   label: "Ships from",
                //   value: "Amazon Fulfilled",
                // },
                {
                  icon: "ph-fill ph-storefront",
                  label: "Sold by",
                  value: product.vendorId?.businessName || "Marketplace Seller",
                },
                {
                  icon: "ph-fill ph-arrow-u-up-left",
                  label: "Returns",
                  value: "Free returns within 7 days",
                },
                {
                  icon: "ph-fill ph-credit-card",
                  label: "Payment",
                  value: "Card, UPI, Net Banking, COD",
                },
                {
                  icon: "ph-fill ph-shield-check",
                  label: "Warranty",
                  value: "As per manufacturer terms",
                },
              ].map((item, i) => (
                <div key={i} className="amz-service-item">
                  <i className={item.icon} />
                  <div>
                    <strong>{item.label}:</strong> {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Related / Reviews ── */}
        {product && (
          <NewArrivalTwo
            currentProduct={product}
            selectedCurrency={selectedCurrency}
          />
        )}
        {product && <Review currentProduct={product} />}

        {/* ══════ LIGHTBOX ══════ */}
        {lightbox && (
          <div
            className="amz-lightbox-overlay"
            onClick={() => setLightbox(false)}
          >
            <button
              className="amz-lightbox-close"
              onClick={() => setLightbox(false)}
            >
              ✕
            </button>
            {lightboxIdx > 0 && (
              <button
                className="amz-lightbox-nav prev"
                onClick={(e) => {
                  e.stopPropagation();
                  setLightboxIdx((i) => i - 1);
                }}
              >
                ‹
              </button>
            )}
            {displayMedia[lightboxIdx]?.type === "image" ? (
              <img
                src={displayMedia[lightboxIdx].url}
                className="amz-lightbox-img"
                onClick={(e) => e.stopPropagation()}
                alt="preview"
              />
            ) : (
              <video
                src={displayMedia[lightboxIdx]?.url}
                controls
                autoPlay
                style={{ maxWidth: "92vw", maxHeight: "92vh" }}
                onClick={(e) => e.stopPropagation()}
              />
            )}
            {lightboxIdx < displayMedia.length - 1 && (
              <button
                className="amz-lightbox-nav next"
                onClick={(e) => {
                  e.stopPropagation();
                  setLightboxIdx((i) => i + 1);
                }}
              >
                ›
              </button>
            )}
          </div>
        )}

        {/* ══════ SHARE MODAL ══════ */}
        {shareModal && (
          <div
            className="amz-share-modal-overlay"
            onClick={() => setShareModal(false)}
          >
            <div
              className="amz-share-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="amz-share-modal-close"
                onClick={() => setShareModal(false)}
              >
                ✕
              </button>
              <h3>Share this product</h3>
              <div className="amz-share-url-row">
                <input
                  type="text"
                  className="amz-share-url-input"
                  value={shareUrl}
                  readOnly
                />
                <button
                  className="amz-share-copy-btn"
                  onClick={() => {
                    navigator.clipboard.writeText(shareUrl);
                    Swal.fire({
                      toast: true,
                      icon: "success",
                      title: "Link copied!",
                      position: "top-end",
                      timer: 1200,
                      showConfirmButton: false,
                    });
                  }}
                >
                  Copy
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "14px 0",
                  color: "#9ca3af",
                  fontSize: 12,
                }}
              >
                <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
                <span style={{ padding: "0 10px" }}>or share via</span>
                <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
              </div>
              <div className="amz-share-icons">
                {[
                  {
                    href: `https://wa.me/?text=${encodeURIComponent(shareUrl)}`,
                    bg: "#25D366",
                    icon: "ph-whatsapp-logo",
                  },
                  {
                    href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                    bg: "#1877F2",
                    icon: "ph-facebook-logo",
                  },
                  {
                    href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
                    bg: "#000",
                    icon: "ph-twitter-logo",
                  },
                  {
                    href: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`,
                    bg: "#0088cc",
                    icon: "ph-telegram-logo",
                  },
                  // {
                  //   href: `https://mail.google.com/mail/u/0/${encodeURIComponent(shareUrl)}`,
                  //   bg: "#EA4335",
                  //   icon: "ph-envelope",
                  // },
                ].map(({ href, bg, icon }) => (
                  <a
                    key={icon}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="amz-share-icon-btn"
                    style={{ background: bg }}
                  >
                    <i className={`ph ${icon}`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductDetailsOne;
